import { render } from "./SettingModal.vue?vue&type=template&id=3b34f128&scoped=true&ts=true"
import script from "./SettingModal.vue?vue&type=script&lang=ts"
export * from "./SettingModal.vue?vue&type=script&lang=ts"

import "./SettingModal.vue?vue&type=style&index=0&id=3b34f128&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b34f128"]])

export default __exports__